import svg from "./chemical-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const ChemicalIcon = makeSvgIcon(svg);

export default ChemicalIcon;
